import React  from "react";
import PageHeader from '../../../../components/layout/PageHeader';
import { Crumb } from "../../../../models/Crumb";
import { Routes } from "../../../../routes";
import RoleTabsContainer from './RoleTabsContainer';

const AddRole = () => {
    var crumbs = new Array<Crumb>();
    crumbs.push(new Crumb("Org Roles", Routes.OrgRoles.path));
    crumbs.push(new Crumb("Add Role", Routes.AddOrgRoles.path));

    return (
        <>
            <PageHeader title={"Add Role"} crumbs={crumbs} />
            <RoleTabsContainer />
        </>
    );
};

export default AddRole;
